import React from 'react';
import { inject, observer } from 'mobx-react';
import './index.scss';

import {toJS} from 'mobx';

import {api} from '../../../functions/api'

import AddDialog from '../../../components/global/addDialog'
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

@inject('internal')
@inject('translate')
@observer
export default class CreateNewClient extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingBtn: false,
            rabat_level: 0
        }
    }

    handleCloseDialog = () => {
        this.props.close();
    }


    handleCreateNewClient = async () => {
        let name = this.client_name.state.value;
        let id_no = this.ico.state.value;
        let ic_dph = this.ic_dph.state.value;
        let cid = this.dic.state.value;
        let street_name = this.street_name.state.value;
        let street_no = this.street_no.state.value;
        let zip = this.zip.state.value;
        let city = this.city.state.value;
        let country = this.country.state.value;

        if(name !== "" && id_no !== "" && street_name !== "" && street_no !== "" && zip !== "" && city !== "" && country !== "" ) {
            this.setState({loadingBtn: true})
            let method = 'post'
            if(this.props.id) {
                method = 'patch'
            }
            
            let idClient = toJS(this.props.id)
            let url = 'clients'
            if(method === 'patch') {
                url += '/' + idClient
            }

            let create_data = await api({
                method: method,
                url: url,
                authorization: this.props.internal.user.access_token,
                params: {
                    name: name,
                    id_no: id_no,
                    id_tax: cid,
                    id_vat: ic_dph,
                    street_name: street_name,
                    street_no: street_no,
                    zip: zip,
                    city: city,
                    country: country,
                    rabat_level: this.state.rabat_level === 0 ? null : this.state.rabat_level
                }
            })

            if((create_data.success === false && create_data.status === 201) ||create_data.success === true) {
                //this.setState({message: "SUCCESS", openSnackbar: true})
                //this.props.showSnackbar(this.state.message, this.state.openSnackbar)
                if(this.props.id) {
                    let editedData = {
                        edit: false,
                        id: null
                    }
                    this.props.internal.setActionEdit(editedData)
                }
                
                this.props.showSnackbar(create_data.data.message, true)
                this.props.close();
                
            }
            else {
                let resultError = "";
                for(let error in create_data.data.data.errors)
                {
                    resultError += create_data.data.data.errors[error] + " "
                }
                this.setState({message: resultError, openSnackbar: true})
                this.props.internal.setSnackbar(resultError, true)
            }
            
            this.setState({loadingBtn: false})
        }
        else {
            let result = "";
            if(name === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.TITLE_REQUIRED + " ";
            }

            if(id_no === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.ID_NO_REQUIRED + " ";
            }

            if(street_name === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.STREET_NAME_REQUIRED + " ";
            }

            if(street_no === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.STREET_NO_REQUIRED + " ";
            }

            if(zip === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.ZIP_REQUIRED + " ";
            }

            if(city === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.CITY_REQUIRED + " ";
            }

            if(country === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.COUNTRY_REQUIRED + " ";
            }

            // if(this.state.rabat_level === null) {
            //     result += this.props.translate.i18n.GLOBAL.ALERTS.RABAT_LEVEL_REQUIRED
            // }
            this.props.internal.setSnackbar(result, true)
        }
    }

    changeRabatLevel = (event) => {
        this.setState({rabat_level: event.target.value})
    }
    
    render() {

        let id = this.props.id
        let data = toJS(this.props.internal.dataForTable.data);
        let tmpData;
        for(let i = 0; i < data.length; i++) {
            if(data[i].id === id) {
                tmpData = data[i]
            }
        }
        return (
            <AddDialog
                className={'dialog-title'}
                open={this.props.open}
                onClose={this.handleCloseDialog}
                title={this.props.title}
                >
                <DialogContent className={'dialog-content'}>
                
                <Grid container spacing={24}>
                    <Grid item className={'grid-item'} xs={12} sm={6}>
                        <CustomInput
                            ref={ref => this.client_name = ref}
                            text={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_CLINET.CLIENT_NAME}
                            id={'client_name'}
                            className={'w-100 mr-10'}
                            value={id ? tmpData.name : ""}
                            required
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                        <CustomInput
                            className={'w-100 mr-10'}
                            ref={ref => this.ico = ref}
                            text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.ICO}
                            id={'ico'}
                            value={id ? tmpData.id_no : ""}
                            required
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                        <CustomInput
                            className={' w-100 mr-10'}
                            ref={ref => this.ic_dph = ref}
                            text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.IC_DPH}
                            id={'ic_dph'}
                            value={id ? tmpData.id_tax : ""}
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                        <CustomInput
                            className={' w-100 mr-10'}
                            ref={ref => this.dic = ref}
                            text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.DIC}
                            value={id ? tmpData.id_vat : ""}
                            id={'dic'}
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                        <CustomInput
                            ref={ref => this.street_name = ref}
                            text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                            id={'adress'}
                            className={"w-100 mr-10"}
                            value={id ? tmpData.street_name : ""}
                            required
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                        <CustomInput
                            ref={ref => this.street_no = ref}
                            text={this.props.translate.i18n.GLOBAL.ADRESS.STREET_NO}
                            id={'street_no'}
                            value={id ? tmpData.street_no : ""}
                            className={"w-100 mr-10"}
                            required
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                        <CustomInput
                            ref={ref => this.zip = ref}
                            text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                            id={'zip'}
                            value={id ? tmpData.zip : ""}
                            className={"w-100 mr-10"}
                            required
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} sm={6} >
                        <CustomInput
                            ref={ref => this.city = ref}
                            text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                            id={'city'}
                            value={id ? tmpData.city : ""}
                            className={"w-100 mr-10"}
                            required
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} >
                        <CustomInput
                            ref={ref => this.country = ref}
                            text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                            id={'country'}
                            value={id ? tmpData.country : ""}
                            className={"w-100 mr-10"}
                            required
                        />
                    </Grid>
                    <Grid item className={'grid-item'} xs={12} >
                        <FormControl fullWidth>
                            <InputLabel className={'input-label'} htmlFor="rabat-level">{this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL_TEXT} *</InputLabel>
                            <Select
                                value={this.state.rabat_level}
                                onChange={this.changeRabatLevel}
                                className={"w-100 mr-10"}
                                inputProps={{
                                    name: 'rabat-level',
                                    id: 'rabat-level',
                                }}
                                fullWidth
                            >
                                <MenuItem value={0}>0%</MenuItem>
                                <MenuItem value={1}>30%</MenuItem>
                                <MenuItem value={2}>20%</MenuItem>
                                <MenuItem value={3}>23%</MenuItem>
                                <MenuItem value={4}>25%</MenuItem>
                                <MenuItem value={5}>27%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCloseDialog} className={'gray-text'}>
                    {this.props.translate.i18n.MODULES.ADMINISTRATORS.CREATE_NEW_ADMIN.CANCEL}
                    </Button>
                    {/* <Button onClick={this.handleCreateNewClient} className={'orange-text'} >
                    {id ?
                        this.props.translate.i18n.GLOBAL.BUTTONS.CHANGE
                        :
                        this.props.translate.i18n.MODULES.ADMINISTRATORS.CREATE_NEW_ADMIN.ADD
                    }
                    </Button> */}
                    <CustomButton
                        justText
                            progressBar={this.state.loadingBtn}
                            onClick={this.handleCreateNewClient}
                            mystyle={'btn-white-bg width-80'}
                            title={
                                id ?
                                    this.props.translate.i18n.GLOBAL.BUTTONS.CHANGE
                                    :
                                    this.props.translate.i18n.MODULES.ADMINISTRATORS.CREATE_NEW_ADMIN.ADD
                            }
                        />
                </DialogActions>
            </AddDialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/create/index.js